// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U04L","importantInfo":"styles_importantInfo__1PMZG"};